<mat-sidenav-container>
    <mat-sidenav #sidenav [opened]="sidenavOpen" [mode]="sidenavOpen ? 'side' : 'over'" class="filter-sidenav"
        perfectScrollbar>

        <mat-accordion displayMode="flat" multi="true">
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h4>Categories</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="categories-wrapper categories-dropdown" perfectScrollbar>
                    <app-category-list [categories]="categories" [categoryParentId]="0"
                        (change)="onChangeCategory($event)"></app-category-list>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h4>Price</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div fxLayout="column wrap" fxLayoutAlign="" class="">
                    <mat-form-field appearance="outline" class="w-100 mt-2">
                        <mat-label><b>Min: </b></mat-label>
                        <input matInput [(ngModel)]="priceFrom" (change)="onChangePrice()" />
                    </mat-form-field>
                </div>
                <div fxLayout="column wrap" fxLayoutAlign="" class="filter-buttons">
                    <mat-slider color="primary" max="200000" min="1" thumb-label="false" [(ngModel)]="priceFrom"
                        (change)="onChangePrice()">
                    </mat-slider>
                </div>
                <div fxLayout="column wrap" fxLayoutAlign="" class="">
                    <mat-form-field appearance="outline" class="w-100 mt-2">
                        <mat-label><b>Max: </b></mat-label>
                        <input matInput [(ngModel)]="priceTo" (change)="onChangePrice()" />
                    </mat-form-field>
                </div>
                <div fxLayout="column wrap" fxLayoutAlign="" class="filter-buttons">
                    <mat-slider color="warn" max="200000" min="1" thumb-label="true" [(ngModel)]="priceTo"
                        (change)="onChangePrice()"></mat-slider>
                </div>
            </mat-expansion-panel>

        </mat-accordion>

    </mat-sidenav>
    <mat-sidenav-content class="all-products" ngClass.gt-sm="p-left">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
            class="filter-row mat-elevation-z1 text-muted">
            <button *ngIf="!sidenavOpen" mat-icon-button (click)="sidenav.toggle()">
                <mat-icon>more_vert</mat-icon>
            </button>
            <div>
                &nbsp;
            </div>
            <!-- <div>
                <a mat-button [matMenuTriggerFor]="sortMenu" #sortMenuTrigger="matMenuTrigger">
                    {{sort}}<mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
                </a>
                <mat-menu #sortMenu="matMenu" xPosition="before" class="app-dropdown" overlapTrigger="true">
                    <span (mouseleave)="sortMenuTrigger.closeMenu()">
                        <button mat-menu-item *ngFor="let sort of sortings" (click)="changeSorting(sort)">
                            <span>{{sort}}</span>
                        </button>
                    </span>
                </mat-menu>
            </div> -->
            <div>
                <a mat-button [matMenuTriggerFor]="countsMenu" #countsMenuTrigger="matMenuTrigger">
                    Show {{count}}<mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
                </a>
                <mat-menu #countsMenu="matMenu" xPosition="before" class="app-dropdown" overlapTrigger="true">
                    <span (mouseleave)="countsMenuTrigger.closeMenu()">
                        <button mat-menu-item *ngFor="let count of counts" (click)="changeCount(count)">
                            <span>{{count}}</span>
                        </button>
                    </span>
                </mat-menu>
                <button mat-icon-button (click)="changeViewType('list', 100)">
                    <mat-icon>view_list</mat-icon>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 33.3)">
                    <mat-icon>view_module</mat-icon>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 25)">
                    <mat-icon>view_comfy</mat-icon>
                </button>
            </div>
        </div>

        <div *ngIf="viewType == 'grid'" fxLayout="row wrap" class="products-wrapper">
            <div *ngFor="let product of products | paginate: { itemsPerPage: count, currentPage: page }" fxFlex="100"
                [fxFlex.gt-sm]="viewCol" fxFlex.sm="50" class="col">
                <mat-card class="product-item text-center">
                    <a [routerLink]="['/products', product.productId, product.productName]" class="image-link">
                        <img [src]="product.productImages[0].imageUrl" alt="">
                    </a> 
                    <h4 class="category text-muted">{{ ( appService.Data.categories | filterById : product.categoryId
                        )?.name }}</h4>
                    <a [routerLink]="['/products', product.productId, product.productName]" class="title text-truncate">
                        {{product.productName}}
                    </a>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="prices">
                        <div fxLayout="column" fxLayoutAlign="center start">
                            <p class="new-price">Rs.{{product.productPrice | number : '1.2-2'}}</p>
                        </div>
                    </div>
                    <div class="divider mt-2"></div>
                    <div class="icons">
                        <app-controls [product]="product" (onOpenProductDialog)="openProductDialog(product)">
                        </app-controls>
                    </div>
                </mat-card>
            </div>
        </div>
        <div *ngIf="viewType == 'list'" fxLayout="row wrap" class="products-wrapper">
            <div *ngFor="let product of products | paginate: { itemsPerPage: count, currentPage: page }" fxFlex="100"
                class="col">
                <mat-card class="product-item">
                    <div fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-xs="40" class="p-2">
                            <a [routerLink]="['/products', product.productId, product.productName]" class="image-link">
                                <img [src]="product.productImages[0].imageUrl" alt="">
                            </a>
                        </div>
                        <div fxFlex="100" fxFlex.gt-xs="60" class="p-2">
                            <h4 class="category text-muted">{{ ( appService.Data.categories | filterById :
                                product.categoryId )?.name }}</h4>
                            <a [routerLink]="['/products', product.productId, product.productName]" class="title">
                                {{product.productName}}
                            </a>
                            <p class="py-1 text-muted lh">{{product.description}}</p>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="prices">
                                <div fxLayout="column" fxLayoutAlign="center start">
                                    <p class="new-price">Rs.{{product.productPrice | number : '1.2-2'}}</p>
                                </div>
                            </div>
                            <div class="divider"></div>
                            <div class="icons">
                                <app-controls [product]="product" (onOpenProductDialog)="openProductDialog(product)">
                                </app-controls>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
        <div *ngIf="products.length > 0" fxLayout="row wrap">
            <div fxFlex="100">
                <mat-card class="p-0 text-center">
                    <pagination-controls class="product-pagination" autoHide="true" maxSize="5"
                        (pageChange)="onPageChanged($event)"></pagination-controls>
                </mat-card>
            </div>
        </div>

    </mat-sidenav-content>
</mat-sidenav-container>